<template>
    <div class="meal">
        <div class="title">
            -&nbsp;&nbsp;购买会员&nbsp;&nbsp;-
            <span class="btn-close" @click="closePopup"></span>
        </div>
        <div class="cards">
            <div class="overflow_box" :style="'width:' + (Info.memberProductList.length * 2.2 + .23) + 'rem'">
                <div 
                    v-for="(item,index) in Info.memberProductList" 
                    :class="{'card_selected' : currentProductId === item.productId}"
                    class="card"
                    @click="selectMeal(item)"
                    :key="index"
                >
                    <div class="tag" v-if="item.isPromotion">疫情特惠</div>
                    <div class="tag" v-if="item.isRecommend">超值推荐</div>
                    <div class="tag" v-if="item.isGoodPrice">专属好价</div>
                    <div class="meal-name">{{ item.title }}</div>
                    <div class="hasPriceCompare" v-if="item.hasPriceCompare">
                        <span class="meal-discountPrice" v-if="item.freeDays == 0">&yen;{{ parseInt(item.discountPrice) }}</span>
                        <span class="meal-discountPrice meal-freeDays" v-else>{{ parseInt(item.freeDays) }}天免费</span>
                        <span class="meal-originPrice">&yen;{{parseInt(item.originPrice) }}</span>
                    </div>
                    <div v-else>
                        <span :class="{'meal-price':true,'delText':item.freeDays != 0}">&yen;{{ parseInt(item.discountPrice) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="text">{{ text[currentProductId] }}</div>
        
        <!-- <div class="button" @click="goPay" v-if="currentpProductType == 24">首月仅{{ parseInt(currentProduct.discountPrice) }}元&nbsp;&nbsp;立即开通</div> -->
        <div class="button"
            @click="goPay"
            v-if="discount != 0"
        >
            {{discount}}折优惠&nbsp;&nbsp;立即开通
        </div>
        <div class="button" @click="goPay" v-else-if="currentpProductType == 24">疫情特惠&nbsp;&nbsp;首月仅{{parseInt(btnDiscountPrice)}}元</div>
        <div class="button" @click="goPay" v-else>立即开通</div>
    </div>
</template>

<script>
    import { MOBILE_API } from "@/constants/api";
    import utils from "@/assets/js/utils";
    const token = utils.getQueryString('token');
    const version = utils.getQueryString('version');
    const source = utils.getQueryString('source');
    const categoryId = utils.getQueryString('categoryId');
    const pageChannelId = utils.getQueryString('pageChannelId');
    const productId = utils.getQueryString('productId');    //商品Id

    export default {
        data() {
            return {
                currentProductId: '',
                text: {},
                btnText: '立即开通',
                currentProduct: {},
                // 套餐类型，23-连续包月，24-优惠连续包月，25-连续包季，26-连续包年，27-1个月，28-1季度，29-一年，71-三天免费
                //54,55,56,57,58,59-85折优惠
                currentpProductType: '',
                freeDays:0,
                discount:0,
                btnDiscountPrice:'',
            }
        },
        props: {
            Info: {
                type: Object
            },
            source: {   // and；ios
                type: String
            }      
        },
        watch: {
            Info() {
                
            }
        },
        mounted() {
            this.formData();
        },
        methods: {
            formData() {
                this.currentProduct = this.Info.memberProductList[0];
                this.currentProductId = this.Info.memberProductList[0].productId;
                this.currentpProductType = this.Info.memberProductList[0].productType;
                this.freeDays = this.Info.memberProductList[0].freeDays || 0;
                this.discount = this.Info.memberProductList[0].discount || 0;

                console.log(this.currentProduct)
                this.Info.memberProductList.forEach((item, index)=>{
                    switch(item.productType) {
                        case 57 :
                            //85折1个月
                            this.text[item.productId] = `选择【连续包月】套餐，每月立省${item.originPrice - (this.typePriceMap(54)||this.typePriceMap(71))}元`;
                            break;
                        case 58 :
                            this.text[item.productId] = `选择【连续包季】套餐，每季立省${item.originPrice - this.typePriceMap(55)}元`;
                            break;
                        case 59 :
                            this.text[item.productId] = `选择【连续包年】套餐，每年立省${item.originPrice - this.typePriceMap(56)}元`;
                            break;
                        case 71 :
                            this.text[item.productId] = `免费期结束后，每月自动续费${item.originPrice}元，可随时关闭`;
                            break;
                        case 54 :
                            this.text[item.productId] = `次月起每月自动续费${item.originPrice}元，可随时关闭`;
                            break;
                        case 55 :
                            this.text[item.productId] = `次季起每季自动续费${item.originPrice}元，可随时关闭`;
                            break;
                        case 56 :
                            this.text[item.productId] = `次年起每年自动续费${item.originPrice}元，可随时关闭`;
                            break;
                        case 23 : 
                            this.text[item.productId] = `每月自动续费${item.discountPrice}元，可随时关闭`;
                            break;
                        case 24 : 
                        case 52 :
                        case 53 :
                            if(item.productType == 24){
                                this.btnDiscountPrice = item.discountPrice;
                            }  
                            this.text[item.productId] = `次月起每月自动续费${item.originPrice}元，可随时关闭`;
                            break;
                        case 25 : 
                            this.text[item.productId] = `每季自动续费${item.discountPrice}元，可随时关闭`;
                            break;
                        case 26 : 
                            // this.text[item.productId] = `每年自动续费${item.discountPrice}元，可随时关闭`;
                            this.text[item.productId] = '次年起每年自动续费308.00元，可随时关闭';
                            break;
                        case 27 : 
                            let typeMap = this.typePriceMap(71) || this.typePriceMap(23) || this.typePriceMap(24) || this.typePriceMap(52) || this.typePriceMap(53)
                            this.text[item.productId] = `选择【连续包月】套餐，每月立省${item.discountPrice - typeMap}元`;
                            break;
                        case 28 : 
                            this.text[item.productId] = `选择【连续包季】套餐，每季立省${item.discountPrice - this.typePriceMap(25)}元`;
                            break;
                        case 29 : 
                            this.text[item.productId] = `选择【连续包年】套餐，每年立省${item.discountPrice - this.typePriceMap(26)}元`;
                            break;
                    }
                })
            },
            selectMeal(item) {
                this.currentProductId = item.productId;
                this.currentpProductType = item.productType;
                this.freeDays = item.freeDays || 0;
                this.discount = item.discount || 0;
                this.currentProduct = item;
                console.log(this.currentProductId, 'this.currentProductId')
            },
            goPay(from) {
                if(from !== 'cancelPop') {
                    gio('track', 'vipOpenPgae_open_click', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx911')
                }
                let isOdd = parseInt(this.Info.memberInfo.userId) % 2 !== 0;
                if(isOdd) {
                    utils.sendLog({
                        token,
                        version,
                        source,
                    }, 'hzxx1203');
                } else {
                    utils.sendLog({
                        token,
                        version,
                        source,
                    }, 'hzxx1202');
                }
                
                let comeFrom = this.Info.needUpgrade ? '113' : '112';
                if(this.source === 'ios'){
                  this.isSameMemberProduct(this.Info);
                }
                let url = this.source === 'ios' ?
                        `hybird://method/openDirectPay?productId=${this.currentProductId}&jsCallBack=jsCallback`:
                        `hybird://method/${this.freeDays != 0?'openFreeDirectPay':'openDirectPay'}?productId=${this.currentProductId}&jsCallBack=jsCallback&productName=${this.currentProduct.title}&comeFrom=${comeFrom}&paymentChannel=wx`;
                setTimeout(()=> {
                    window.location.href = url;
                },100)
                
            },
            goHelp() {
                let url = window.location.href.split('?')[0]
                    url = encodeURIComponent(url.split("member_ios").join("pay_help_ios"));
            
                window.location.href = "hybird://method/openNewWindow?url=" + url;
            },
            typePriceMap(productType) {
                let discountPrice;
                this.Info.memberProductList.some((item, index)=>{
                    if(item.productType === productType) {
                        discountPrice = (
                            productType === 24 || 
                            productType === 52 || 
                            productType === 53 ||
                            productType === 54 || 
                            productType === 55 ||
                            productType === 56
                        ) ? item.originPrice :item.discountPrice;
                        return true;
                    }
                    
                })
                return discountPrice;
            },
            getGioParams(){
                return {
                    categoryId,
                    pageChannelId,
                    isVip: this.Info.memberInfo.isMember,
                    productId: productId || this.currentProductId
                }
            },
            // 相同套餐emit事件；
            isSameMemberProduct(Info){
                Info.memberProductList.map((item)=>{
                    if(item.productId == Info.memberInfo.iosProductId){
                        this.$emit("toggleMemberProductPopup");
                        return;
                    }
                })
            },

            closePopup() {
                this.$emit('popupClosed');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .meal {
        position: relative;
        // margin-top: -.44rem;
        background: #ffffff;
        border-radius: .44rem .44rem 0 0;
        box-shadow: 0px -6px 12px 0px 
		rgba(144, 117, 67, 0.1);
        padding-bottom: .1rem;  
        .title {
            height: 1.1rem;
            line-height: 1.1rem;
            font-size: .3rem;
            color: #919294;
            text-align: center;
            border-bottom: .01rem solid #f3f3f3;
            margin-bottom: .4rem;
            position: relative;

            .btn-close {
                width: .66rem;
                height: .66rem;
                background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/membership/icon_popup_close.png) no-repeat center;
                background-size: .22rem .22rem;
                top: .1rem;
                right: .1rem;
                display: block;
                position: absolute;
            }
        }
        .meal-tit {
            padding: .47rem .4rem .2rem;
            display: flex;
            justify-content: space-between;
            .title {
                font-family: PingFangSC-Medium;
                font-size: .28rem;
                color: #161616;
                font-weight: bolder;
                img {
                    width: .49rem;
                    height: .36rem;
                    margin-right: .08rem;
                }
            }
            .help {
                font-family: PingFangSC-Regular;
	            font-size: .22rem;
	            color: #bec0c2;
                display: flex;
                align-items: center;
                &::after {
                    content: '';
                    display: inline-block;
                    width: .24rem;
                    height: .24rem;
                    background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_help.png) 0 0 no-repeat;
                    background-size: 100%;
                    margin-left: .1rem;
                }
            }
        }
        .cards {
            height: 2.5rem;
            width: 100%;
            overflow-x: scroll;
            padding-left: .2rem;
            position: relative;
            .overflow_box {
                width: auto;
                height: 2.5rem;
                overflow-x: hidden;
                padding-top: .1rem;
            }
            .card {
                float: left;
                width: 1.96rem;
                height: 2.37rem;
                background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/vipprice_card_normal.png) no-repeat;
                background-size: 100% 100%; 
                margin-left: .23rem;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: center;
                position: relative;
                span {
                    display: block;
                }
                .tag {
                    position: absolute;
                    top: -.1rem;
                    left: -.01rem;
                    width: 1.48rem;
                    height: .36rem;
                    line-height: .38rem;
                    border-radius: .18rem .18rem .18rem 0;
                    background-image: linear-gradient(90deg, 
		#ff6533 0%, 
		#ff2222 100%);
                    font-family: PingFangSC-Medium;
	                font-size: .22rem;
	                color: #ffffff;
                    font-weight: bolder;
                    padding: .01rem 0 0 .0rem;
                }
                .meal-name {
                    font-family: PingFangSC-Semibold;
                    font-weight: bold;
	                font-size: .32rem;
	                color: #553511;
                    line-height: .6rem;
                }
                .meal-discountPrice,.meal-price {
                    font-family: PingFangSC-Semibold;
                    font-weight: bold;
	                font-size: .48rem;
	                color: #b26530;
                    line-height: .5rem;
                }
                .meal-freeDays{
                    font-size: .38rem;
                }
                .meal-originPrice {
                    font-family: PingFangSC-Regular;
	                font-size: .24rem;
                    text-decoration: line-through;
                    color: #bec0c2;
                    line-height: .3rem;
                }
            }
            .card_selected {
                background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/vipprice_card.png) no-repeat;
                background-size: 100% 100%; 
                .meal-discountPrice,.meal-price {
	                color: #b26530;
                }
            }
        }
        .text {
	        height: .3rem;
	        line-height: .3rem;
	        font-size: .22rem;
	        color: #919294;
            text-align: left;
            text-indent: .4rem;
            margin-top: .22rem;
        }
        .paychannel {
            padding: 0 .6rem 0 .4rem;
            box-sizing: border-box;
            border-top: solid #f5f5f5 .2rem;
            margin-top: .46rem;
            .tit {
                font-family: PingFangSC-Medium;
	            font-size: .28rem;
	            color: #7b531e;
                text-align: left;
                // text-indent: .4rem;
                height: .84rem;
                line-height: 1rem;
            }
            .channel-item {
                height: 1rem;
                line-height: 1rem;
                font-size: .24rem;
                color: #919294;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .name {
                    display: flex;
                    align-items: center;
                    &::before {
                        content: '';
                        display: inline-block;
                        width: .44rem;
                        height: .44rem;
                        background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/paystyle_icon_wechat.png) 0 0 no-repeat;
                        background-size: 100%;
                        margin-right: .2rem;
                    }
                }
                .checked {
                    display: inline-block;
                    width: .4rem;
                    height: .4rem;
                    background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/selected.png) 0 0 no-repeat;
                    background-size: 100%;
                }
            }

        }
        .button {
            width: 6.7rem;
            height: .88rem;
            background-color: #ff571d;
            color: #fff;
            font-size: .3rem;
            line-height: .88rem;
            border-radius: .44rem;
            margin: .5rem auto;
        }
        .delText{
            text-decoration: line-through;
        }
    }
</style>